import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let deliverSwiperWr = document.querySelectorAll('.deliver-swiper-wr');
deliverSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    if (!swiperEl || swiperEl.swiper) {
      return;
    }

    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    if (!slidesCount) {
      return;
    }

    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 20,
      slidesPerView: 1,
      speed: 500,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true,
      } : undefined,
      breakpoints: {
        640: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
        851: {
          spaceBetween: 20,
          slidesPerView: 4,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 5,
        },
        1200: {
          spaceBetween: 35,
          slidesPerView: 5,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      }
    });
    swiperObserver(swiper);
  }
});
